import React from 'react';

// ============================================================================
// COMPONENTE: PREMIUM LOCK (CADEADO VISUAL)
// OBJETIVO: Envolver qualquer conteúdo que precise de bloqueio (Teaser).
// ============================================================================

const PremiumLock = ({ isLocked, children, title = "Conteúdo Exclusivo", onUpgrade }) => {
    // Se não estiver bloqueado, renderiza o conteúdo normalmente
    if (!isLocked) return children;

    return (
        <div className="relative rounded-xl overflow-hidden border border-gray-200 shadow-sm group bg-white">
            {/* Conteúdo Ofuscado (Blur) */}
            <div className="blur-sm opacity-30 pointer-events-none select-none filter grayscale p-4 min-h-[300px]">
                {children}
            </div>

            {/* Overlay de Venda */}
            <div className="absolute inset-0 bg-gradient-to-b from-transparent to-[#1a1e30]/90 z-10 flex flex-col items-center justify-center text-center p-6">
                <div className="w-16 h-16 bg-[#C5A059] rounded-full flex items-center justify-center shadow-2xl mb-4 animate-bounce-slow">
                    <i className="fas fa-lock text-white text-2xl"></i>
                </div>
                
                <h3 className="text-2xl font-serif font-bold text-[#20243B] bg-white/90 px-6 py-2 rounded-lg backdrop-blur-md shadow-lg mb-2">
                    {title}
                </h3>
                
                <p className="text-white/90 text-sm max-w-md mb-8 font-medium drop-shadow-md leading-relaxed">
                    Este material faz parte do módulo avançado (2ª Fase). <br/>
                    Desbloqueie agora para acesso total ao ecossistema.
                </p>
                
                <button 
                    onClick={onUpgrade} 
                    className="bg-[#C5A059] text-white px-8 py-3 rounded-full font-bold text-xs uppercase tracking-wider hover:bg-white hover:text-[#C5A059] transition-all shadow-xl border-2 border-[#C5A059] hover:scale-105 active:scale-95"
                >
                    <i className="fas fa-crown mr-2"></i> Desbloquear Acesso Pro
                </button>
            </div>
        </div>
    );
};
export default PremiumLock;